export default __webpack_public_path__ + "static/media/32x32_RemoveShoppingCartRounded.9048be72.svg";